// Simple represenation of a company. This is used when listing off various work
// experience.

export default class Company {
	constructor(name, url) {
		this.name = name
		this.url = url
	}
}
